module.exports = __webpack_public_path__ + "img/31.592ad525.png";